module.exports = __webpack_public_path__ + "static/img/declare_two.dfc951d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/declare_two.jpg
// module id = EeIb
// module chunks = 1